module.exports = __webpack_public_path__ + "static/img/s4.9cd714c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s4.png
// module id = rt7s
// module chunks = 1